import { Directive, Input, ElementRef, OnInit } from '@angular/core';
import { Roles } from '../../model';


@Directive({
  selector: '[appRoleId2roleName]'
})
export class RoleId2roleNameDirective implements OnInit {

  @Input() id: any;

	constructor(private el: ElementRef) { }

  getRoleNameFromID(): string {
    if(Roles[this.id]) {
      if(this.id === Roles.none) {
        return "-";
      } else {
        return Roles[this.id];
      }
    }
    // if (this.id === Roles.admin ) {
    //   return Role.ADMINISTRATOR;
    // } else if (this.id === Roles.engineer ) {
    //   return Role.ENGINEER;
    // } else {
    //   return Role.UNKNOWN;
    // }
  }

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    nativeElement.innerText = this.getRoleNameFromID();
  }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/roleid2rolename/roleid2rolename.directive.ts